import { render, staticRenderFns } from "./DashboardCustomCampaign.vue?vue&type=template&id=449c7c28&scoped=true&"
import script from "./DashboardCustomCampaign.vue?vue&type=script&lang=js&"
export * from "./DashboardCustomCampaign.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCustomCampaign.vue?vue&type=style&index=0&id=449c7c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449c7c28",
  null
  
)

export default component.exports